import { motion } from 'framer-motion';
import { FaGraduationCap } from 'react-icons/fa';
import education from '../data/education.json';
import { useLanguage } from '../LanguageContext';
import './Education.css';

const degrees = education.filter(
  (item) => item.degree.includes('Bachelor') || item.degree.includes('Masters')
);

function Education() {
  const { t } = useLanguage();

  return (
    <section className="education-section">
      <h2 className="education-title">{t.education.title}</h2>

      <div className="education-list">
        {degrees.map((item, i) => (
          <motion.div
            className="education-card glass"
            key={item.degree}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
          >
            <div className="education-icon">
              <FaGraduationCap />
            </div>
            <div className="education-body">
              <span className="education-years">
                {item.year_start} — {item.year_end}
              </span>
              <h3 className="education-degree">{item.degree}</h3>
              <p className="education-institution">{item.institution}</p>
              <p className="education-location">{item.location}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}

export default Education;
